/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Loading from '../../../components/atoms/Loading'
import {
  Button,
  Col,
  Collapse,
  Container,
  Row,
  Table,
  Card
} from 'react-bootstrap'
import BreadCrumb from '../../../components/Label/Breadcrumb'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { convertDateWithTime } from '../../../helpers/constants'
import api from '../../../config/AxiosInstance'
import { BadgeStatusCOA } from '../../../components/atoms/StatusLabel'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

function CreateMaterialTransfer() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState({
    page: false,
    submit: false
  })
  const [data, setData] = useState(null)
  const [collapsible, setCollapsible] = useState(true)
  const columns = [
    { key: 'sequence', label: 'No' },
    { key: 'item_name', label: 'Item' },
    {
      key: 'status',
      label: 'Status COA',
      className: 'text-end',
      component: (value) => {
        if (value.status) {
          return <BadgeStatusCOA text={value?.status} />
        }
        return '-'
      }
    },
    {
      key: 'batch',
      label: 'Batch',
      className: 'text-end',
      component: (value) => value?.batch_name || '-'
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end',
      component: (value) =>
        value?.total_pack ? `${value?.total_pack} ${value?.uom_pack}` : '-'
    },
    {
      key: 'total_qty',
      label: 'Total Qty',
      className: 'text-end',
      component: (value) => (value?.qty ? `${value?.qty} ${value?.uom}` : '-')
    },
    {
      key: 'coa_document',
      label: 'COA Document',
      className: 'text-end',
      component: (value) => {
        if (value?.coa_document) {
          return (
            <div key={value?.id}>
              <Button variant="transparent" className="text-primary">
                {value?.coa_document?.split('/').pop()}
              </Button>
            </div>
          )
        }
        return '-'
      }
    },
    {
      key: 'coa_pd',
      label: 'COA MD',
      className: 'text-end',
      component: (value) =>
        value?.coa_pd ? convertDateWithTime(value?.coa_pd, 'DD-MM-YYYY') : '-'
    },
    {
      key: 'coa_ed',
      label: 'COA ED',
      className: 'text-end',
      component: (value) =>
        value?.coa_ed ? convertDateWithTime(value?.coa_ed, 'DD-MM-YYYY') : '-'
    },
    {
      key: 'label_pd',
      label: 'LABEL MD',
      className: 'text-end',
      component: (value) =>
        value?.label_pd
          ? convertDateWithTime(value?.label_pd, 'DD-MM-YYYY')
          : '-'
    },
    {
      key: 'label_ed',
      label: 'LABEL ED',
      className: 'text-end',
      component: (value) =>
        value?.label_ed
          ? convertDateWithTime(value?.label_ed, 'DD-MM-YYYY')
          : '-'
    }
  ]
  const handleBack = () => {
    const { code, seriesNumber, ...newStateValue } = state
    navigate(`/arrival/material-transfer`, {
      replace: true,
      state: newStateValue
    })
  }
  const handleSubmit = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        submit: true
      }))
      const payload = data
      const res = await api.post('/inbound/ml-draft/create', payload)
      const { status } = res
      if (status === 200) {
        toast.success('ML Draft Created!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        handleBack()
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        submit: false
      }))
    }
  }
  const fetchData = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        page: true
      }))
      const payload = {
        tr_code: state?.code
      }
      const res = await api.post(`/inbound/ml-plan/show-entry`, payload)
      const { data: dataRes } = res
      if (dataRes.success) {
        setData({
          ...dataRes.data,
          series_number: state?.seriesNumber || '',
          items: dataRes?.data?.items
        })
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      handleBack()
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        page: false
      }))
    }
  }
  useEffect(() => {
    fetchData()
  }, [state])
  if (loading.page) {
    return <Loading />
  }
  return (
    <Container fluid className="px-4 mb-5">
      <Toaster />
      <Row className="mb-4">
        <Col md={12}>
          <BreadCrumb
            label={state?.code}
            link={'/arrival/material-transfer'}
            back="Material Transfer"
            labelSub={'CREATE ML DRAFT'}
            status=""
            type=""
            stateValue={{
              start_date: state?.start_date,
              end_date: state?.end_date,
              tr: state?.tr
            }}
          />
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row>
          <Col xs={12} md={4}>
            <small style={labelStyle}>SERIES</small>
            <h5 className="mt-1" style={{ fontSize: '1.1rem' }}>
              {state?.seriesNumber || ''}
            </h5>
          </Col>
          <Col xs={12} md={4}>
            <small style={labelStyle}>SOURCE WAREHOUSE</small>
            <h5 className="mt-1" style={{ fontSize: '1.1rem' }}>
              {data?.source || ''}
            </h5>
          </Col>
          <Col xs={12} md={4}>
            <small style={labelStyle}>TARGET AT WAREHOUSE</small>
            <h5 className="mt-1" style={{ fontSize: '1.1rem' }}>
              {data?.destination}
            </h5>
          </Col>
        </Row>
      </Card>

      <Card style={cardFilterStyle}>
        <Row className="mb-3">
          <Col
            md={12}
            className="d-flex justify-content-between align-items-center"
          >
            <h5 style={headerTitleStyle} className="mb-0">
              Item & COA
            </h5>
            {collapsible ? (
              <ChevronUp
                className="text-secondary"
                onClick={() => setCollapsible(!collapsible)}
                size={18}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <ChevronDown
                className="text-secondary"
                onClick={() => setCollapsible(!collapsible)}
                size={18}
                style={{ cursor: 'pointer' }}
              />
            )}
          </Col>
        </Row>
        <Collapse in={collapsible}>
          <div id="example-collapse-text">
            <Row>
              <Col md={12}>
                <Table
                  responsive
                  hover
                  className="shadow-sm bg-white"
                  style={{
                    fontSize: '13px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: 0
                  }}
                >
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {columns.map((column) => (
                        <th
                          className={`align-middle p-2 ${column.className}`}
                          key={column.key}
                          style={tableHeaderStyle}
                        >
                          <span>{column.label}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.length === 0 && (
                      <tr>
                        <td colSpan={columns.length} className="p-2">
                          <div className="d-flex justify-content-center">
                            <span className="text-secondary">
                              No data available
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                    {data?.items?.length > 0 &&
                      data?.items?.map((item, index) => (
                        <tr key={`${item.id}-${index}`}>
                          {columns.map((column) => (
                            <td
                              key={column.key}
                              className={`align-middle p-2 ${column.className}`}
                            >
                              {column.key === 'sequence' && index + 1}
                              {column.component && column.component(item)}
                              {!column.component && item[column.key]}
                            </td>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>
        </Collapse>
      </Card>

      <Row className="mt-4">
        <Col md={12}>
          <div className="d-flex justify-content-between">
            <Button
              type="button"
              variant="light"
              className="text-danger fw-bold border"
              onClick={handleBack}
            >
              Cancel
            </Button>
            <Button
              className={`${
                loading.submit
                  ? 'btn-secondary opacity-25'
                  : 'btn-primary-orange'
              } fw-bold`}
              onClick={handleSubmit}
              disabled={loading.submit}
            >
              Submit
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default CreateMaterialTransfer
